(function($) {
  var ElevenReview = (function(win, doc) {
    let Review;
    let API = {};

    function ElevenReview(option) {

      if (option.hasOwnProperty("api")) {
        API.uri = option.api.uri || "";
        API.headers = option.api.headers || {};
        delete option.api;
      }

      Object.assign(this, {
        init: false,
        products: new Map(),
        photoReviews: new Map(),
        offset: 0,
        limit: 10,
        total: 0,
        next: false,
        plugin: {}
      }, option);
      
      this.plugin.handlebars = win.Handlebars || null;
      this.loadingSpinner = {
        el: document.getElementById("loading-spinner") || null,
        visible: function(flag) {
          if (this.el === null) {
            return;
          }
          this.el.hidden = !flag;
        }
      }

      this.el = {
        btnMore: document.getElementById("btnMore") || null,
        reviewTotal: document.getElementById("reviewTotal") || null
      }

      setup.call(this);
      init.call(this);
      
      return this;
    }

    async function setup() {

      const $review = this;

      this.plugin.handlebars.registerHelper("starRating", function(value, options) {
        return parseInt(value) * 20;
      });

      const btnMore = $review.el.btnMore;
      btnMore.addEventListener('click', function(e) {
        $review.moreReviews();
      }, false);
    }

    async function init() {
      await this.getProducts();
      await this.getReviews();
      await renderPhotoSwiper.call(this);

      this.init = true;
    }

    var moreReviews = async function(limit) {
      const $review = this;

      if ($review.next === false) {
        return;
      }

      offset = $review.offset;
      limit = limit || $review.limit;

      const btnMore = $review.el.btnMore;
      btnMore.innerText = reviewSettings["text-loading"];      
      await $review.getReviews(offset, limit);
    }

    var getProducts = async function() {
      const $review = this;

      try {
        const res = await fetch("/products.json", {
          method: "get"
        });
        const json = await res.json();
        const products = await json.products;
        for(let i in products) {  
          $review.products.set(products[i].id, {
            title: products[i].title,
            images: products[i].images,
            type: products[i].product_type,
            handle: products[i].handle            
          });
        }
      } catch (error) {
        return false;
      }
      return true;
    }

    var getReviews = async function(offset, limit) {
      const $review = this;

      if (offset === null || typeof offset === "undefined") {
        offset = $review.offset;
      }
      limit = limit || $review.limit;
      

      $review.loadingSpinner.visible(true);
      const queryStrings = "?offset="+offset+"&limit="+limit;
      
      try {
        const res = await fetch(API.uri + queryStrings, {
          method: "get",
          headers: API.headers
        });

        const json = await res.json();
        const reviews = await json.reviews;
        $review.total = json.total;
        $review.next = json.hasNext;

        const tpl = $review.plugin.handlebars.compile(document.getElementById("review-con-tpl").innerHTML);
        
        for(let reviewIndex in reviews) {
          let review = reviews[reviewIndex];
          const product = $review.products.get(review.productId);
          if (product) {
            $review.plugin.handlebars.registerHelper('ifCustomerId', function(opt) {
              if (customerId !== "" && reviews[reviewIndex].customerId !== 0 && Number(customerId) === Number(reviews[reviewIndex].customerId)) {
                return opt.fn(this);
              }
            });          

            document.querySelector(".review-contents-container").insertAdjacentHTML('beforeend', tpl({
              review: review, 
              product: product,
              productImage: product.images[0].src,
              myReviewText: reviewSettings["text-my-review"]
            }));
          }
        }
      } catch (error) {
        return false;
      } finally {
        $review.loadingSpinner.visible(false);
        getReviewsComplete.call(this, offset, limit);
      }
      return true;
    }

    var getReviewsComplete = function(offset, limit) {
      const $review = this;

      if ($review.total <= 0) {
        return;
      }

      $review.offset = offset + limit;

      const reviewTotal = $review.el.reviewTotal;
      if($review.total > 0) {
        reviewTotal.innerHTML = reviewSettings["text-total"]+" ("+$review.total+")";
      } else {
        reviewTotal.innerHTML = reviewSettings["text-empty-reviews"];
      }

      const btnMore = $review.el.btnMore;
      if ($review.el !== null) {
        btnMore.innerText = reviewSettings["button-more"]+" (+"+($review.total-(offset + limit))+")";
        btnMore.style.visibility = $review.next && "visible" || "hidden";
      }
    }

    var getPhotoReviews = async function(offset, limit) {     
      const $review = this; 
      const queryStrings = "?offset="+offset+"&limit="+limit;

      let images = [];

      try {
        const res = await fetch(API.uri + "/image-urls" + queryStrings, {
          method: "get",
          headers: API.headers
        });        
        const json = await res.json();
        images = json.imageUrls;
        for(let i in images) {  
          $review.photoReviews.set(images[i].id, {
            image: images[i].url,
          });
        }
      } catch (error) {
        console.log(error)
        return false;
      }
      return images;
    }

    var renderPhotoSwiper = async function() {
      const $review = this;
      const images = await getPhotoReviews.call($review, 0, 10);

      if (images === false || images.length === 0) {
        return;
      }

      const tpl = $review.plugin.handlebars.compile(document.getElementById("image-review-tpl").innerHTML);
      document.querySelector(".photo-swiper-wrapper").insertAdjacentHTML('beforeend', tpl(images));

      $review.photoReviewSwiper = new Swiper('.photo-swiper-container', {
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        spaceBetween: 8,
        allowTouchMove: true,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-hidden',
          prevEl: '.swiper-button-hidden',
        },
        breakpoints : {
          768 : {
            navigation: {
              nextEl: '.photo-review-next',
              prevEl: '.photo-review-prev',
            },
            slidesPerGroup: 7,
            allowTouchMove: false,
          }
        },
        on: {
          init: function() {
            this.slidesClick = [];
            const slides = this.slides;
            for (const i in slides) {
              if (Object.hasOwnProperty.call(slides, i)) {
                const slide = slides[i];
                const clickHandler = async function(e) {
                  const reviewId = this.getAttribute("data-review-id");
                  await popupPhotoReviewVisible.call($review, parseInt(reviewId));
                }
                this.slidesClick.push(clickHandler);
                slide.addEventListener('click', clickHandler, false);
              }
            }

            const popupPhotoReview = document.querySelector(".review-popup-container");
            popupPhotoReview.addEventListener('click', function(e) {              
              if (e.target === this) {
                e.preventDefault();
                $review.popupPhotoReviewVisible(false);
              }              
            }, false);

            popupPhotoReview.querySelector(".review-popup-close").addEventListener('click', function(e) {
              e.preventDefault();
              $review.popupPhotoReviewVisible(false);
            }, false);
          }
        }
      });
    }

    var popupPhotoReviewVisible = async function(photoReviewId) {

      const $review = this;
      const popupPhotoReview = document.querySelector(".review-popup-container");

      if (popupPhotoReview === null) {
        return;
      }

      if (photoReviewId === false) {
        popupPhotoReview.style.visibility = "hidden";
        doc.body.classList.remove("popup-photo-review-active");
        doc.getElementById("scrollTopBtn").style.display = "block";
        return;
      }

      let photoReview = $review.photoReviews.get(photoReviewId);
      if (photoReview === "undefined") {
        return;
      }

      if (typeof photoReview.createdAt === "undefined") {
        try {
          const res = await fetch([API.uri, photoReviewId].join('/'), {
            method: "get",
            headers: API.headers
          });        
          const json = await res.json();
          for (const key in json.review) {
            if (Object.hasOwnProperty.call(json.review, key)) {
              photoReview[key] = json.review[key];
            }
          }
        } catch (error) {
          return false;
        }
      }

      const product = $review.products.get(photoReview.productId);      
      const tpl = $review.plugin.handlebars.compile(document.getElementById("review-popup-tpl").innerHTML);

      popupPhotoReview.children[0].children[0].innerHTML = tpl({
        review: photoReview, 
        product: product
      });

      popupPhotoReview.style.visibility = "visible";
      doc.body.classList.add("popup-photo-review-active");
      doc.getElementById("scrollTopBtn").style.display = "none";
    }

    var mapUnshift = function(map, value) {
      const arr = Array.from(map) ;
      arr.unshift(value);
      return new Map(arr);
    }

    var prototypes = {
      getProducts: getProducts,
      getReviews: getReviews,
      moreReviews: moreReviews,
      popupPhotoReviewVisible: popupPhotoReviewVisible,
    }

    Object.keys(prototypes).forEach(function (protoMethod) {
      ElevenReview.prototype[protoMethod] = prototypes[protoMethod];
    });

    return ElevenReview;
  })(window, document);

  var elevenReview = new ElevenReview({
    api: {
      uri: "https://ktnbpeply1.execute-api.ap-northeast-2.amazonaws.com/production/shopify/reviews",
      headers: {
        "x-shop-alias": shopAlias,
        "x-shop-customer-id": customerId
      }
    }
  });
})(jQuery);